import {
  DEFAULT_FILTERS,
  FILTERS,
  FILTERS_NAME,
  PRODUCT_CATEGORIES_BY_PERSON,
  REVIEWS_CATEGORY,
} from '../constants/filters';
import { OrganizationType } from '../constants/organizationType';
import { ITagOption } from '../interfaces/productTags';

type TGetDefaultFilters = {
  organizationType: OrganizationType;
  reviewTagInParams?: ITagOption;
};

export const getDefaultFilters = ({ organizationType, reviewTagInParams }: TGetDefaultFilters): FILTERS => {
  const commonFilters = {
    ...DEFAULT_FILTERS,
    [FILTERS_NAME.ORGANIZATION_TYPE]: organizationType,
    ...(reviewTagInParams && { [FILTERS_NAME.REVIEW_TAG]: reviewTagInParams }),
    ...(organizationType === OrganizationType.MFI && {
      [FILTERS_NAME.USER_RATING_TYPE]: REVIEWS_CATEGORY.MORE_THAN_10,
    }),
  };

  if (organizationType === OrganizationType.BANK) {
    return {
      ...commonFilters,
      [FILTERS_NAME.USER_RATING_TYPE]: REVIEWS_CATEGORY.MORE_THAN_500,
      [FILTERS_NAME.PRODUCT_CATEGORY_BY_PERSON]: PRODUCT_CATEGORIES_BY_PERSON.ALL,
    };
  }

  if (organizationType === OrganizationType.INSURANCE_COMPANY) {
    return {
      ...commonFilters,
      [FILTERS_NAME.USER_RATING_TYPE]: REVIEWS_CATEGORY.MORE_THAN_300,
    };
  }

  if ([OrganizationType.NPF, OrganizationType.UNIVERSITY, OrganizationType.BOOKMAKER].includes(organizationType)) {
    return {
      ...commonFilters,
      [FILTERS_NAME.USER_RATING_TYPE]: REVIEWS_CATEGORY.ALL,
    };
  }

  return {
    ...commonFilters,
    [FILTERS_NAME.USER_RATING_TYPE]: REVIEWS_CATEGORY.MORE_THAN_100,
  };
};
